import { useTranslation } from 'react-i18next'

import { useUserBankTaps } from '@store'

import styles from './Taps.module.scss'

type Props = {
  className?: string
}

export const Taps = ({ className }: Props) => {
  const taps = useUserBankTaps()
  const { t } = useTranslation()

  return (
    <div className={className}>
      <div className={styles.counter}>
        <span className={styles.text}>{t('ds.taps.taps')}</span>
        <span className={styles.number}>{taps?.balance || 0}</span>
      </div>
    </div>
  )
}
